import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import DriverOnroadTest from "@/components/application/driver-onroad-test/DriverOnroadTest";
import ApplicationStepper from "@/components/application/ApplicationStepper";

const DriverOnroadAssessmentPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />

        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          HIVED Partner Driver On-Road Assessment
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Complete the assessment to proceed with your application
        </p>

        <div className="max-w-2xl mx-auto">
          <DriverOnroadTest />
        </div>
      </div>
    </AppLayout>
  );
};

export default DriverOnroadAssessmentPage;
